// extracted by mini-css-extract-plugin
export var childrenContainer = "_46-0";
export var virtualScrollArea = "_46-1";